import React from "react";

const LoadingSpinner = ({
  size = "1x",
  color = "#E34607",
  text = "Loading...",
  showText = true,
  className = "",
}) => {
  const spinnerStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    color: color,
    fontSize: size === "1x" ? "16px" : size === "2x" ? "20px" : "24px",
  };

  return (
    <div style={spinnerStyle} className={className}>
      <i className={`fas fa-spinner fa-spin fa-${size}`}></i>
      {showText && <span>{text}</span>}
    </div>
  );
};

export default LoadingSpinner;
